// Report-slug to route mapping now lives in the shared report registry and is
// resolved by hooks/reports/resolveReportAccess.firstAllowedReportPath (the
// single source of truth). This module stays as a thin, stable entry point so
// the route guards (RequireReportAccess, RequireCommissionAccess) keep importing
// getFirstAllowedReportPath from here without change.
//
// The guard path map intentionally omits `book-trend` (a broker whose first
// grant is book-trend falls back to the default report path); that divergence is
// encoded verbatim in the registry via `inGuardPathMap` and reproduced by the
// resolver, so behaviour is byte-identical to the previous local map.
import { firstAllowedReportPath } from '../../hooks/reports/resolveReportAccess';

/**
 * Returns the path for the broker's first allowed report.
 * Falls back to settlement-age if no allowedReports or slug not found.
 */
export function getFirstAllowedReportPath(allowedReports?: string[]): string {
  return firstAllowedReportPath(allowedReports);
}
